module.exports = __webpack_public_path__ + "img/gift.bde2a03c.png";